<template>
  <div id="printcontent" style="position:absolute;left:-50000px;top:-50000px">
    <table
      cellspacing="0"
      cellpadding="0"
      border="0"
      style="width:100%;
            table-layout: fixed;
            border-top:1px solid #e9eaec;
            border-left: 1px solid #e9eaec;"
      class="print_table"
    >
      <thead>
        <template v-for="(item,index) in printColumns">
          <th :style="{width:item.width + 'px'}" :key="index">{{item.title}}</th>
        </template>
      </thead>
      <tbody>
        <template v-for="(item,index) in printTableData">
          <tr :key="index" style="text-align:center" class="unit">
            <template v-for="(temp,key,num) in item">
              <td :key="index + '-' + num" v-if="key !== 'scoreJsonText'">
                <p
                  style="box-sizing: border-box;overflow: hidden;text-overflow: ellipsis;white-space: normal;word-break: break-all;line-height: 23px;"
                >{{rowData(item,key)}}</p>
              </td>
              <td v-else :key="index + '_' + num">
                <p
                  style="text-align:left"
                  v-for="(r,t) in temp.split('\n')"
                  :key="index + '__' + t"
                >{{r}}</p>
              </td>
            </template>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import registerData from "@/assets/json/register.json";
export default {
  props: {
    printColumns: {
      type: Array
    },
    printTableData: {
      type: Array
    },
    printTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      stateList: [
        {
          label: "草稿",
          value: 0,
          color: "rgb(64, 142, 232)"
        },
        {
          label: "学校待审核",
          value: 1,
          color: "rgb(64, 142, 232)"
        },
        { label: "学校未通过", value: 2, color: "rgb(252, 91, 91)" },
        { label: "分会待审核", value: 3, color: "rgb(64, 142, 232)" },
        { label: "分会未通过", value: 4, color: "rgb(252, 91, 91)" },
        { label: "分会通过", value: 5, color: "rgb(51, 204, 154)" }
      ],
      projectList: [],
      tableNum: 0
    };
  },
  watch: {
    printTableData(value) {
      this.tableNum = 0;
      for (let i = 0; i < 500; i++) {
        if (value.slice(24 * i, 24 * (i + 1)).length > 0) {
          this.tableNum = this.tableNum + 1;
        }
      }
    }
  },
  mounted() {
    this.projectList = [
      ...registerData.sportsProjectList,
      ...registerData.sunshineProject
    ];
  },
  computed: {
    rowData() {
      return (data, key) => {
        let value = null;
        this.printColumns.filter(t => {
          if (t.key == key) {
            value = data[key];
            if (key === "gender") {
              value = data[key] === 0 ? "女" : "男";
            } else if (key === "projectFirst") {
              this.projectList.filter(item => {
                if (item.value === value) value = item.label;
              });
            } else if (key === "sportsLevel") {
              
              value = value === 1 ? "普通生" : value === 2 ? "体育生" : "高水平";
            } else if (key === "state") {
              this.stateList.filter(item=>{
                if(item.value === value) value = item.label;
              })
            }
          }
        });
        return value;
      };
    }
  }
};
</script>
<style lang="less" scoped>
table {
  word-wrap: break-word;
  word-break: break-all;
  tbody {
    td {
      width: 30%;
    }
  }
}
</style>